import { CURRENCY_CODE } from "@/lib/constant";
import { sendGTMEvent } from "@next/third-parties/google";
import {
  findDiscount,
  getItemCategories,
  getSelectedVariants,
  getVariants,
} from "@repo/lib/helpers";
import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback } from "react";

const useAddToCartEvent = () => {
  const isGTMEnabled = useFeatureFlag("gtm");
  const handleAddToCartEvent = useCallback(
    (product, payLoad, couponName) => {
      if (!isGTMEnabled) {
        return;
      }
      const { price, sku, name, salePrice, productOptions, brand, categories } =
        product;
      const { quantity } = payLoad;
      sendGTMEvent({
        event: "add_to_cart",
        currency: CURRENCY_CODE,
        value: price,
        items: [
          {
            item_id: sku,
            item_name: name,
            affiliation: "",
            coupon: couponName || "",
            discount: findDiscount(price, salePrice),
            index: 0,
            item_brand: brand || "",
            ...getItemCategories(categories),
            item_list_id: "",
            item_list_name: "",
            item_variant:
              getSelectedVariants(productOptions) ||
              getVariants(productOptions),
            price,
            quantity,
          },
        ],
      });
    },
    [isGTMEnabled]
  );

  return { handleAddToCartEvent };
};

export default useAddToCartEvent;
